import React from 'react';
import classnames from 'classnames';
import { RadioGroup } from '@headlessui/react';

export default function RadioList({
  selected,
  options,
  onSelect,
  label,
  disabled,
}) {
  const lastIndex = (options || []).length - 1;
  return (
    <RadioGroup value={selected} onChange={onSelect} disabled={disabled}>
      <RadioGroup.Label className="sr-only">{label}</RadioGroup.Label>
      <div className="-space-y-px rounded-md bg-white">
        {options.map((option, optionIdx) => (
          <RadioGroup.Option
            key={option.name}
            value={option}
            className={({ checked }) => {
              return classnames('relative flex border p-4 focus:outline-none', {
                'rounded-tl-md': optionIdx === 0,
                'rounded-tr-me': optionIdx === 0,
                'rounded-bl-md': optionIdx === lastIndex,
                'rounded-br-md': optionIdx === lastIndex,
                // "z-10": checked,
                'border-green-200': checked,
                'bg-green-50': checked,
                'border-gray-200': !checked,
                'cursor-not-allowed': disabled,
                'cursor-pointer': !disabled,
              });
            }}
          >
            {({ active, checked }) => (
              <>
                <span
                  className={classnames(
                    'mt-0.5 h-4 w-4 shrink-0 rounded-full border flex items-center justify-center',
                    {
                      'bg-green-600': checked,
                      'border-transparent': checked,
                      'bg-white': !checked,
                      'border-gray-300': !checked,
                      'ring-2': active,
                      'ring-offset-2': active,
                      'ring-green-600': active,
                      'cursor-not-allowed': disabled,
                      'cursor-pointer': !disabled,
                    },
                  )}
                  aria-hidden="true"
                >
                  <span className="rounded-full bg-white w-1.5 h-1.5" />
                </span>
                <span className="ml-3 flex flex-col">
                  <RadioGroup.Label
                    as="span"
                    className={classnames('block text-sm font-medium', {
                      'text-green-900': checked,
                      'text-gray-900': !checked,
                    })}
                  >
                    {option.name}
                  </RadioGroup.Label>
                  <RadioGroup.Description
                    as="span"
                    className={classnames('block text-sm', {
                      'text-green-700': checked,
                      'text-gray-500': !checked,
                    })}
                  >
                    {option.description}
                  </RadioGroup.Description>
                </span>
              </>
            )}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  );
}
